import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Conseils from "@/pages/Conseils";
import Article from "@/pages/Article";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Cookies from "@/pages/Cookies";
import Carte from "@/pages/Carte";

const Shell = () => {
  const { pathname } = useLocation();
  const isCard = pathname === "/carte";

  return (
    <>
      <ScrollToTop />
      {!isCard && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/conseils" element={<Conseils />} />
          <Route path="/conseils/:slug" element={<Article />} />
          <Route path="/carte" element={<Carte />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/cookies" element={<Cookies />} />
          {/* Redirections des anciennes pages vers les sections de l'accueil */}
          <Route path="/service" element={<Navigate to="/#service" replace />} />
          <Route path="/pourquoi-avelis" element={<Navigate to="/#avantages" replace />} />
          <Route path="/fonctionnement" element={<Navigate to="/#fonctionnement" replace />} />
          <Route path="/a-propos" element={<Navigate to="/#a-propos" replace />} />
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isCard && <Footer />}
      {!isCard && <MobileBar />}
      <Toaster position="bottom-center" richColors />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
